import { appSettings } from './settings'

// The API's two public form endpoints. Values are the URL slugs the API's router mounts
// (`router.post('/waitlist')`, `router.post('/delete-account')`), which is why they diverge from
// the member keys.
export enum PublicFormRouteEnum {
  Waitlist = 'waitlist',
  DeleteAccount = 'delete-account',
}

// Absolute URL of a public form route on the API. The browser posts to it cross-origin on purpose:
// only a hop a browser makes carries an `Origin` header and the visitor's own IP, which is what the
// API's origin allow-list and rate limiter are checked against.
//
// Returns null when the public API URL is missing, so the caller can report a failure instead of
// posting: an interpolated `undefined` base yields a relative path, which the website's SSR
// catch-all (src/server/index.ts:139) answers with 200 and a page of HTML for any method.
export const publicFormUrl = (route: PublicFormRouteEnum): string | null =>
  appSettings.publicApiUrl ? `${appSettings.publicApiUrl}/public-form/${route}` : null
